import React from "react";

export default function Article({ articleClass, children }) {
	return (
		<article style={{ overflow: "hidden" }} className={articleClass}>
			{children}
		</article>
	);
}
